export default "__VITE_ASSET__CDXXhz63__"